<template>
  <v-simple-table dense>
    <thead>
      <tr>
        <th>Material Type</th>
        <th>Description</th>
        <th>Platinum</th>
        <th>Palladium</th>
        <th>Rhodium</th>
      </tr>
    </thead>
    <tbody
      v-for="(summary, index) in report.metal_summary"
      :key="index"
    >
      <tr>
        <td>
          {{ summary.material_type }}
        </td>
        <td colspan="4">
          <v-simple-table>
            <tbody>
              <tr v-show="$store.getters.can('api.view_lot_report')">
                <td>Contained Assays</td>
                <td>{{ summary.pt_assay | toFixed(3) | addCommas }}</td>
                <td>{{ summary.pd_assay | toFixed(3) | addCommas }}</td>
                <td>{{ summary.rh_assay | toFixed(3) | addCommas }}</td>
              </tr>
              <tr v-show="$store.getters.can('api.view_lot_report')">
                <td>Contained Metals</td>
                <td>{{ summary.pt_contained_toz | toFixed(3) | addCommas }} toz</td>
                <td>{{ summary.pd_contained_toz | toFixed(3) | addCommas }} toz</td>
                <td>{{ summary.rh_contained_toz | toFixed(3) | addCommas }} toz</td>
              </tr>
              <tr v-show="$store.getters.can('api.view_lot_report')">
                <td>Return Rates</td>
                <td>{{ (summary.pt_return_rate * 100).toFixed(2) }}%</td>
                <td>{{ (summary.pd_return_rate * 100).toFixed(2) }}%</td>
                <td>{{ (summary.rh_return_rate * 100).toFixed(2) }}%</td>
              </tr>
              <tr>
                <td>Returnable Ounces</td>
                <td>{{ summary.pt_returnable_toz | toFixed(3) | addCommas }} toz</td>
                <td>{{ summary.pd_returnable_toz | toFixed(3) | addCommas }} toz</td>
                <td>{{ summary.rh_returnable_toz | toFixed(3) | addCommas }} toz</td>
              </tr>
              <tr>
                <td>Avg. Hedge $/Oz</td>
                <td><dollar-sign />{{ summary.pt_hedge_rate | toFixed(2) | addCommas }}</td>
                <td><dollar-sign />{{ summary.pd_hedge_rate | toFixed(2) | addCommas }}</td>
                <td><dollar-sign />{{ summary.rh_hedge_rate | toFixed(2) | addCommas }}</td>
              </tr>
              <tr>
                <td>Metals Value</td>
                <td><dollar-sign />{{ summary.pt_total_value | toFixed(2) | addCommas }}</td>
                <td><dollar-sign />{{ summary.pd_total_value | toFixed(2) | addCommas }}</td>
                <td><dollar-sign />{{ summary.rh_total_value | toFixed(2) | addCommas }}</td>
              </tr>
            </tbody>
          </v-simple-table>
        </td>
      </tr>
    </tbody>
  </v-simple-table>
</template>

<script>

export default {
  name: 'FinalReportSummaryMetals',
  props: {
    report: {
      type: Object,
      required: true
    }
  }
}
</script>
